import { UserCompanySummary } from '../models/user-company.model';

/** Legacy `_returnFilteredCompanies`. */
export const selectableCompanies = (
  companies: UserCompanySummary[],
  canManageMultiBuyerUsers: boolean,
): UserCompanySummary[] =>
  canManageMultiBuyerUsers
    ? companies
    : companies.filter((company) => !company.isMultiBuyer);
